import produce from 'immer';
import api from '../../actions/api';

import card from './card';
import integrations from './integrations';
import team from './team';
import bots from './bots';
import replies from './replies';
import quantities from './quantities';
import crm from './crm';

export default function rootReducer(state = null, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case api.workspaces.retrieve.successType:
            case api.workspaces.create.successType:
            case api.workspaces.update.successType:
                return action.result;
            case api.onboarding.update.successType:
                draft.onboarding = action.result;
                break;
            default:
                card(draft, action);
                integrations(draft, action);
                team(draft, action);
                bots(draft, action);
                replies(draft, action);
                quantities(draft, action);
                crm(draft, action);
        }
    });
}
